import React from 'react';
import {
  Box, CircularProgress, DialogActions, IconButton, Tooltip
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { useTranslation } from 'react-i18next';

const NodeEditorDialogActions = ({
  onDelete = null,
  onCancel,
  onSave,
  deleteDisabled = false,
  cancelDisabled = false,
  saveDisabled = false,
  saving = false,
  saveLabel = '',
  testRunButton = null,
}) => {
  const { t } = useTranslation();

  return (
    <DialogActions
      sx={{
        px: { xs: 1.5, sm: 3 },
        py: 2,
        gap: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box
        data-testid="node-editor-delete-actions"
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
        }}
      >
        {onDelete && (
          <Tooltip title={t('common.delete', 'Delete')}>
            <span>
              <IconButton
                onClick={onDelete}
                color="error"
                disabled={deleteDisabled || saving}
                aria-label={t('common.delete', 'Delete')}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Box>
      <Box
        data-testid="node-editor-secondary-actions"
        sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', justifyContent: 'flex-end', flexShrink: 0 }}
      >
        {testRunButton}
        <Tooltip title={t('common.cancel', 'Cancel')}>
          <span>
            <IconButton
              onClick={onCancel}
              disabled={cancelDisabled || saving}
              aria-label={t('common.cancel', 'Cancel')}
            >
              <CloseIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={saving
          ? t('common.saving', 'Saving...')
          : saveLabel || t('common.save', 'Save')}>
          <span>
            <IconButton
              onClick={onSave}
              color="primary"
              disabled={saveDisabled || saving}
              aria-label={saving
                ? t('common.saving', 'Saving...')
                : saveLabel || t('common.save', 'Save')}
            >
              {saving ? <CircularProgress size={22} color="inherit" /> : <SaveIcon />}
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </DialogActions>
  );
};

export default NodeEditorDialogActions;
